import React from 'react';
import Text from './text';

export default function TextInputPasswordlWrapper(props) {
  return <Text {...props} type='password' />;
}